import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { OptionCodeSnippet } from '@/pages/dashboard/llm/constants';
import CodeCurl from '@/pages/dashboard/llm/overview/code/curl';
import CodeLangchain from '@/pages/dashboard/llm/overview/code/langchain';
import CodeOpenAI from '@/pages/dashboard/llm/overview/code/openAI';
import urlJoin from 'url-join';

import { useState } from 'react';

type Props = {
  model: string;
  apiKey: string;
  endpoint: string;
};
const PlaygroundTextGenerationAPI = ({ model, apiKey, endpoint }: Props) => {
  const options = Object.values(OptionCodeSnippet);
  const [option, setOption] = useState<OptionCodeSnippet>(
    OptionCodeSnippet.cURL
  );

  return (
    <>
      <Tabs
        value={option}
        onValueChange={(e) => setOption(e as OptionCodeSnippet)}
        className="w-full"
      >
        <TabsList variant={'outline'}>
          {options.map((tab) => (
            <TabsTrigger key={tab} value={tab} variant={'outline'}>
              {tab}
            </TabsTrigger>
          ))}
        </TabsList>
        <div className="mt-6">
          <TabsContent value={OptionCodeSnippet.cURL}>
            <CodeCurl
              model={model}
              apiKey={apiKey}
              endpoint={urlJoin(endpoint, '/chat/completions')}
            />
          </TabsContent>
          <TabsContent value={OptionCodeSnippet.OpenAI}>
            <CodeOpenAI model={model} apiKey={apiKey} endpoint={endpoint} />
          </TabsContent>
          <TabsContent value={OptionCodeSnippet.Langchain}>
            <CodeLangchain model={model} apiKey={apiKey} endpoint={endpoint} />
          </TabsContent>
        </div>
      </Tabs>
    </>
  );
};

export default PlaygroundTextGenerationAPI;
